import { BoxContentStyles } from "./BoxContent";

type BoxContentProps = {
  src: string;
  heading: string;
  content: string;
}

function BoxContent({src, heading, content}: BoxContentProps) {
  return (
    <BoxContentStyles>
      <img src={src} alt={heading} />
      <h2>{heading}</h2>
      <p>{content}</p>
    </BoxContentStyles>
  );
}

export default BoxContent;